import { createContext } from 'react';

export const UserCodeContext = createContext('');
